// extracted by mini-css-extract-plugin
module.exports = {"homeText":"Home_homeText__2aP2h","textShow":"Home_textShow__1d-A0"};